













































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getImplement, UnitProjectImplementData, emptyImplement } from '@/api/heritageUnit/unitProject'
import { getLookupByType, DDLItem, getUnitProjectProposalPhase, getUnitProjectPhase } from '@/api/common/select'
import { enFirstType, enLookupType } from '@/configs/enums'
import { validateIntKey, validateLngLat, showVaildMsg } from '@/configs/validate'
import { getDDLItem, tryToInt, getDDLName } from '@/configs/functions'
import Element from 'element-ui'
import { UserData } from '@/api/systemManage/user'
import { namespace } from 'vuex-class'
import { OfficialDocData } from '@/api/officialDoc/doc'
import DocSelector from '@/components/officialDoc/select.vue'
import { UploadOptData } from '@/api/common/upload'
import { AttachInfo } from '@/api/common/attach'
import singleFile from '@/components/upload/singleFile.vue'
import { schemeFormat, imageFormat } from '@/configs/fileTypes'
import FormDialog from '@/components/dialog/formDialog.vue'

const UserModule = namespace('user')

const getFormRules = (form: { [key: string]: string }) => {
  return {
    ProposalName: [{ required: true, message: '请输入方案名称', trigger: 'blur' }],
    // proposalDate: [{ required: true, message: '请输入开始年月', trigger: 'blur' }],
    ProposalPhase: [{ required: true, validator: validateIntKey('请选择设计阶段'), trigger: 'blur' }],
    ProposalDesignUnit: [{ required: true, message: '请输入设计单位', trigger: 'blur' }],
  }
}
@Component({
  components: { FormDialog, DocSelector, singleFile }
})
export default class UnitProjectImplementForm extends Vue {
  public name = 'UnitProjectImplementForm'
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false

  @UserModule.Getter("userInfo")
  public curUser!: UserData

  public expandNames: string[] = ['proposal', 'project', 'proposalFund', 'projectFund']
  public loading: boolean = false
  public schemeExt: string = schemeFormat
  public photoExt: string = imageFormat
  //勘察设计方案
  public hasScheme: boolean = false
  //方案评审意见
  public hasOpinion: boolean = false
  public hasPhoto: boolean = false
  public hasPlan: boolean = false
  //设计阶段
  public proposalPhaseList: DDLItem[] = []
  public projectPhaseList: DDLItem[] = []
  public form: UnitProjectImplementData = Object.assign({}, emptyImplement)
  public rules = getFormRules(this.form)
  public $refs!: {
    formData: Element.Form
    sfScheme: singleFile
    sfOpinion: singleFile
    sfPhoto: singleFile
    sfPlan: singleFile
  }
  get proposalDate(): string {
    const f = this.form
    var data = ''
    if (f.ProposalBeginYear > 0 && f.ProposalBeginMonth > 0) {
      data = f.ProposalBeginYear.toString() + '-' + f.ProposalBeginMonth.toString()
    }
    return data
  }
  set proposalDate(data: string) {
    const f = this.form
    if (data != '') {
      let sp = data.split('-')
      f.ProposalBeginYear = tryToInt(sp[0])
      f.ProposalBeginMonth = tryToInt(sp[1])
    }
    else {
      f.ProposalBeginYear = f.ProposalBeginMonth = 0
    }
  }
  get projectStartDate(): string {
    const f = this.form
    var data = ''
    if (f.ProjectStartYear > 0 && f.ProjectStartMonth > 0) {
      data = f.ProjectStartYear.toString() + '-' + f.ProjectStartMonth.toString()
    }
    return data
  }
  set projectStartDate(data: string) {
    const f = this.form
    if (data != '') {
      let sp = data.split('-')
      f.ProjectStartYear = tryToInt(sp[0])
      f.ProjectStartMonth = tryToInt(sp[1])
    }
    else {
      f.ProjectStartYear = f.ProjectStartMonth = 0
    }
  }
  get projectEndDate(): string {
    const f = this.form
    var data = ''
    if (f.ProjectEndYear > 0 && f.ProjectEndMonth > 0) {
      data = f.ProjectEndYear.toString() + '-' + f.ProjectEndMonth.toString()
    }
    return data
  }
  set projectEndDate(data: string) {
    const f = this.form
    if (data != '') {
      let sp = data.split('-')
      f.ProjectEndYear = tryToInt(sp[0])
      f.ProjectEndMonth = tryToInt(sp[1])
    }
    else {
      f.ProjectEndYear = f.ProjectEndMonth = 0
    }
  }
  get checkDate(): string {
    const f = this.form
    var data = ''
    if (f.ProjectCheckYear > 0 && f.ProjectCheckMonth > 0) {
      data = f.ProjectCheckYear.toString() + '-' + f.ProjectCheckMonth.toString()
    }
    return data
  }
  set checkDate(data: string) {
    const f = this.form
    if (data != '') {
      let sp = data.split('-')
      f.ProjectCheckYear = tryToInt(sp[0])
      f.ProjectCheckMonth = tryToInt(sp[1])
    }
    else {
      f.ProjectCheckYear = f.ProjectCheckMonth = 0
    }
  }
  get acceptanceDate(): string {
    const f = this.form
    var data = ''
    if (f.ProjectAcceptanceYear > 0 && f.ProjectAcceptanceMonth > 0) {
      data = f.ProjectAcceptanceYear.toString() + '-' + f.ProjectAcceptanceMonth.toString()
    }
    return data
  }
  set acceptanceDate(data: string) {
    const f = this.form
    if (data != '') {
      let sp = data.split('-')
      f.ProjectAcceptanceYear = tryToInt(sp[0])
      f.ProjectAcceptanceMonth = tryToInt(sp[1])
    }
    else {
      f.ProjectAcceptanceYear = f.ProjectAcceptanceMonth = 0
    }
  }
  public onFileChange(data: { opts: UploadOptData, file: AttachInfo }) {
    const opt = data.opts
    const hasFile = data.file.Id > 0
    const f = this.form
    switch (opt.refType) {
      case f.AttachTypeScheme:
        this.hasScheme = hasFile
        break
      case f.AttachTypeOpinion:
        this.hasOpinion = hasFile
        break
      case f.AttachTypePlan:
        this.hasPlan = hasFile
        break
      case f.AttachTypePhoto:
        this.hasPhoto = hasFile
        break
      default:
        break
    }
  }
  public getProposalDoc(info: { data: OfficialDocData, refTo: string }) {
    this.form.ProposalDocId = info.data.Id
  }
  public created() {
  }
  public fetchSource() {
    const firstType = enFirstType.Select
    if (this.proposalPhaseList.length === 0) {
      getUnitProjectProposalPhase(firstType).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          this.proposalPhaseList = data
        }
      })
    }
    if (this.projectPhaseList.length === 0) {
      getUnitProjectPhase(firstType).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          this.projectPhaseList = data
        }
      })
    }
  }
  public mounted() {
    window.eventBus.$on("openUnitProjectImplementForm", (data: UnitProjectImplementData) => {
      this.fetchSource()
      this.fetchData(data)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('openUnitProjectImplementForm')
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public fetchData(info: UnitProjectImplementData) {
    this.open()
    if (info.Id > 0 || (info.AttachTypeScheme == 0 || info.AttachTypePhoto == 0 || info.AttachTypePlan == 0 || info.AttachTypePhoto == 0)) {
      //1修改已有记录，从后台拿最新的记录信息 2新增的时候从后台获取附件枚举信息
      this.loading = true
      getImplement(info.Id).then((response: { data: any }) => {
        this.form = response.data
        this.loading = false
      }).catch((error: any) => {
        console.log(error)
      })
    }
    else {
      this.form = Object.assign({}, info)
    }
  }
  public sendData(data: UnitProjectImplementData) {
    window.eventBus.$emit("submitUnitProjectImplementForm", data)
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        const f = Object.assign({}, this.form)
        f.ProposalPhaseName = getDDLName(this.proposalPhaseList, f.ProposalPhase)
        f.ProjectPhaseName = getDDLName(this.projectPhaseList, f.ProjectPhaseId)
        f.UserName = this.curUser.DisplayName
        this.sendData(f)
        this.close()
      }
      else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
}
